export default {
    namespaced:true,
    state: {
      popupVisible: false,
      texto: '',
      txtBtnCancel: '',
      txtBtnOk: '',
      fun1: null,
      fun2: null,
      popupMenu: false
    },

    mutations: {

      openMenu (state) {
        state.popupMenu = true
      },

      closeMenu (state) {
        state.popupMenu = false
      },

      open (state, object) {
        state.texto = object.txt
        state.txtBtnCancel = object.txtBtnCancel
        state.txtBtnOk = object.txtBtnOk
        state.fun1 = object.fCancel
        state.fun2 = object.fOk
        state.popupVisible = true
      },

      close (state, object) {
        state.popupVisible = false
      },

      btnCancel (state) {
        state.popupVisible = false
        if (state.fun1 != null) 
        {
          state.fun1()
        }  
        state.texto = ''
        state.txtBtnCancel = ''
        state.txtBtnOk = ''
        state.fun1 = null
        state.fun2 = null
      },

      btnOk (state) {
        state.popupVisible = false
        if (state.fun2 != null)
        {
          state.fun2()
        }
        state.texto = ''
        state.txtBtnCancel = ''
        state.txtBtnOk = ''
        state.fun1 = null
        state.fun2 = null
      }

    }

}


// WEBPACK FOOTER //
// ./src/store/modules/popup.js